import { create } from 'zustand'

export type Language = 'pl' | 'en' | 'uk' | 'ru'

interface LanguageState {
  language: Language
  setLanguage: (language: Language) => void
}

export const useLanguage = create<LanguageState>((set) => ({
  language: 'pl',
  setLanguage: (language) => set({ language }),
}))

export const languageNames = {
  pl: 'Polski',
  en: 'English',
  uk: 'Українська',
  ru: 'Русский',
}